import { createContext, useContext } from 'react';

// Types.
import Agent from '../types/instance/Agent';

// Set the internal context object.
let agents: Agent[] = [];

// Define the context type, including the update function.
export type AgentContextType = {
    agents: Agent[];
    setAgents: (agents: Agent[]) => void;
}

// Define the context object.
export const AgentContext = createContext<AgentContextType>({ agents: agents, setAgents: agents => console.warn('No agents set.', agents) });
AgentContext.displayName = 'Agents';

// Export the update function for the context object.
export const useAgents = () => useContext(AgentContext);